import React, { useState, useEffect, useContext } from 'react';
import { Button } from '../../components/ui/button';
import axios from 'axios';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { UserContext } from '../../contexts/UserContext';

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

// Funkcja do konwersji daty ISO 8601 na format datetime-local
const formatDateForInput = (isoDate) => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  // Konwersja do formatu yyyy-MM-ddThh:mm
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const RequestForm = ({ onNavigate, workPermitId }) => {
  console.log("przekazane id", workPermitId);
  const [orderData, setOrderData] = useState({
    orderNumber: '',
    workPermitNumber: '',
    turbineId: '',
    scopeOfWorkId: '',
    workScopeReal: '',
    supervisorId: '',
    preparerId: '',
    team: [],
    startDateTime: '',
    endDateTime: '',
    workPermitId: null,
  });
  const [otherScopeId, setOtherScopeId] = useState(null);
  const { user } = useContext(UserContext);
  const [turbines, setTurbines] = useState([]);
  const [scopesOfWork, setScopesOfWork] = useState([]);
  const [users, setUsers] = useState([]);
  const [outsideUsers, setOutsideUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isAddingSupervisor, setIsAddingSupervisor] = useState(false);
  const [isAddingPreparer, setIsAddingPreparer] = useState(false);
  const [isAddingTeamMember, setIsAddingTeamMember] = useState([]);
  const [usernameInput, setUsernameInput] = useState('');
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [isOrderNumberLocked, setIsOrderNumberLocked] = useState(false);
  const [isWorkPermitNumberLocked, setIsWorkPermitNumberLocked] = useState(false);
  const [pendingWorkPermits, setPendingWorkPermits] = useState([]);
  console.log("user", user);

  const fetchPendingWorkPermits = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(`${API_BASE_URL}/workpermit/?status=pen`, config);
      console.log('wpresponse:', response);
      const filteredPending = response.data.filter((permit) => permit.status === 'planned_approved');
      console.log('Pending Work Permits from API:', filteredPending);
      setPendingWorkPermits(filteredPending);

      if (workPermitId) {
        const workPermitData = filteredPending.find((permit) => permit.id === workPermitId);
        if (workPermitData) {
          console.log('Znaleziono work permit:', workPermitData);
          setOrderData({
            orderNumber: workPermitData.order_number || '',
            workPermitNumber: workPermitData.work_permit_number,
            turbineId: workPermitData.turbine,
            scopeOfWorkId: workPermitData.work_scope,
            workScopeReal: workPermitData.work_scope_real || '',
            supervisorId: workPermitData.team_data?.team_leader || '',
            preparerId: workPermitData.team_data?.person_responsible_for_preparation_of_work_place || '',
            team: workPermitData.team_data?.team.filter(
              (id) => id !== workPermitData.team_data?.team_leader && 
                      id !== workPermitData.team_data?.person_responsible_for_preparation_of_work_place
            ) || [],
            startDateTime: formatDateForInput(workPermitData.planned_date_start),
            endDateTime: formatDateForInput(workPermitData.planned_date_end),
            workPermitId: workPermitData.id,
          });
          setIsCreateMode(false);
          setIsAddingTeamMember(
            workPermitData.team_data?.team?.length > 0
              ? Array(workPermitData.team_data.team.length).fill(false)
              : [false]
          );
        } else {
          console.error('Nie znaleziono work permitu o id:', workPermitId);
          setErrorMessage('Work permit not found.');
        }
      }
    } catch (error) {
      console.error('Error fetching work permits:', error);
      setErrorMessage('Failed to load work permits.');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setErrorMessage('');
        setSuccessMessage('');
        const token = localStorage.getItem('access_token');
        if (!token) throw new Error('No authentication token found');

        const config = {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        };

        const [turbinesResponse, scopesResponse, usersResponse, outsideUsersResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/turbines/`, config),
          axios.get(`${API_BASE_URL}/scopeofworks/`, config),
          axios.get(`${API_BASE_URL}/users/`, config),
          axios.get(`${API_BASE_URL}/users/minimal/`, config),
        ]);

        const turbinesData = turbinesResponse.data || [];
        const scopesData = scopesResponse.data || [];
        const usersData = usersResponse.data || [];
        const outsideUsersData = outsideUsersResponse.data || [];

        console.log('Pobrane dane z /turbines/:', turbinesData);
        console.log('Pobrane dane z /scopeofworks/:', scopesData);
        console.log('Pobrane dane z /users/:', usersData);
        console.log('Pobrane dane z /users/minimal/:', outsideUsersData);

        setTurbines(turbinesData);
        setScopesOfWork(scopesData);
        setUsers(usersData);
        setOutsideUsers(outsideUsersData);
        setIsAddingTeamMember([false]);
        const otherScope = scopesData.find(scope => scope.name === 'Other' && scope.company === 1);
        setOtherScopeId(otherScope ? otherScope.id : null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setErrorMessage('Failed to load data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchPendingWorkPermits();
  }, [workPermitId]);

  const turbineOptions = turbines
    .filter((turbine) => turbine.company === 1)
    .map((turbine) => ({
      value: turbine.id,
      label: `${turbine.turbine_number} (${turbine.model_data?.name || 'N/A'})`,
    }));

  const scopeOptions = scopesOfWork
    .filter((scope) => scope.company === 1 && scope.name !== 'Other')
    .map((scope) => ({
      value: scope.id,
      label: scope.name || 'N/A',
    }));

  const orderOptions = pendingWorkPermits
    .filter((permit) => permit.order_number && permit.order_number.trim() !== '')
    .map((permit) => ({
      value: permit.order_number,
      label: permit.order_number,
      workPermitNumber: permit.work_permit_number || '',
      turbineId: permit.turbine,
      scopeOfWorkId: permit.work_scope,
      id: permit.id,
    }));

  const workPermitOptions = pendingWorkPermits
    .filter((permit) => permit.work_permit_number && permit.work_permit_number.trim() !== '')
    .map((permit) => ({
      value: permit.work_permit_number,
      label: permit.work_permit_number,
      orderNumber: permit.order_number || '',
      turbineId: permit.turbine,
      scopeOfWorkId: permit.work_scope,
      id: permit.id,
    }));

  const supervisorOptions = users.map((user) => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name} (${user.username})`,
  }));

  const preparerOptions = users.map((user) => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name} (${user.username})`,
  }));

  const memberOptions = users.map((user) => ({
    value: user.id,
    label: `${user.first_name} ${user.last_name} (${user.username})`,
  }));

  const selectedSupervisor = outsideUsers.find((u) => u.id === orderData.supervisorId);
  const selectedPreparer = outsideUsers.find((u) => u.id === orderData.preparerId);

  const turbineLabel = turbines.find((t) => t.id === orderData.turbineId)?.turbine_number || 'N/A';
  const scopeLabel = scopesOfWork.find((s) => s.id === orderData.scopeOfWorkId)?.name || 'N/A';

  const handleOrderNumberChange = (selectedOption) => {
    if (selectedOption) {
      const selectedPermit = pendingWorkPermits.find(
        (permit) => permit.order_number === selectedOption.value
      );
      if (selectedPermit) {
        setOrderData((prev) => ({
          ...prev,
          orderNumber: selectedOption.value,
          workPermitNumber: selectedOption.workPermitNumber || '',
          turbineId: selectedOption.turbineId || '',
          scopeOfWorkId: selectedOption.scopeOfWorkId || '',
          workPermitId: selectedOption.id,
          supervisorId: selectedPermit.team_data?.team_leader || '',
          preparerId: selectedPermit.team_data?.person_responsible_for_preparation_of_work_place || '',
          team: selectedPermit.team_data?.team.filter(
            (id) =>
              id !== selectedPermit.team_data?.team_leader &&
              id !== selectedPermit.team_data?.person_responsible_for_preparation_of_work_place
          ) || [],
          startDateTime: formatDateForInput(selectedPermit.planned_date_start),
          endDateTime: formatDateForInput(selectedPermit.planned_date_end),
        }));
        setIsWorkPermitNumberLocked(true);
        setIsAddingTeamMember(
          selectedPermit.team_data?.team?.length > 0
            ? Array(selectedPermit.team_data.team.length).fill(false)
            : [false]
        );
      }
    } else {
      setOrderData((prev) => ({
        ...prev,
        orderNumber: null,
        workPermitNumber: null,
        turbineId: '',
        scopeOfWorkId: '',
        workPermitId: null,
        supervisorId: '',
        preparerId: '',
        team: [],
        startDateTime: '',
        endDateTime: '',
      }));
      setIsWorkPermitNumberLocked(false);
      setIsAddingTeamMember([false]);
    }
    setErrorMessage('');
  };

  const handleWorkOrderChange = (selectedOption) => {
    if (selectedOption) {
      const selectedPermit = pendingWorkPermits.find(
        (permit) => permit.work_permit_number === selectedOption.value
      );
      if (selectedPermit) {
        setOrderData((prev) => ({
          ...prev,
          workPermitNumber: selectedOption.value,
          orderNumber: selectedOption.orderNumber || '',
          turbineId: selectedOption.turbineId || '',
          scopeOfWorkId: selectedOption.scopeOfWorkId || '',
          workPermitId: selectedOption.id,
          supervisorId: selectedPermit.team_data?.team_leader || '',
          preparerId: selectedPermit.team_data?.person_responsible_for_preparation_of_work_place || '',
          team: selectedPermit.team_data?.team.filter(
            (id) =>
              id !== selectedPermit.team_data?.team_leader &&
              id !== selectedPermit.team_data?.person_responsible_for_preparation_of_work_place
          ) || [],
          startDateTime: formatDateForInput(selectedPermit.planned_date_start),
          endDateTime: formatDateForInput(selectedPermit.planned_date_end),
        }));
        setIsOrderNumberLocked(true);
        setIsAddingTeamMember(
          selectedPermit.team_data?.team?.length > 0
            ? Array(selectedPermit.team_data.team.length).fill(false)
            : [false]
        );
      }
    } else {
      setOrderData((prev) => ({
        ...prev,
        workPermitNumber: null,
        orderNumber: null,
        turbineId: '',
        scopeOfWorkId: '',
        workPermitId: null,
        supervisorId: '',
        preparerId: '',
        team: [],
        startDateTime: '',
        endDateTime: '',
      }));
      setIsOrderNumberLocked(false);
      setIsAddingTeamMember([false]);
    }
    setErrorMessage('');
  };

  const handleManualInputChange = (field, value) => {
    setOrderData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'workPermitNumber' || field === 'orderNumber' ? { workPermitId: null } : {}),
    }));
  };

  const handleChange = (field, selectedOption, index = null) => {
    const newValue = selectedOption ? selectedOption.value : '';
    const allSelectedIds = [
      orderData.supervisorId,
      orderData.preparerId,
      ...orderData.team,
    ].filter((id) => id);

    if (newValue && allSelectedIds.includes(newValue) && field !== 'scopeOfWorkId') {
      setErrorMessage('This person is already assigned to another role.');
      return;
    }

    if (field === 'scopeOfWorkId') {
      if (selectedOption && selectedOption.__isNew__) {
        setOrderData((prev) => ({
          ...prev,
          scopeOfWorkId: otherScopeId,
          workScopeReal: selectedOption.label,
        }));
      } else {
        setOrderData((prev) => ({
          ...prev,
          scopeOfWorkId: newValue,
          workScopeReal: '',
        }));
      }
    } else if (field === 'team' && index !== null) {
      setOrderData((prev) => {
        const newTeam = [...prev.team];
        newTeam[index] = newValue;
        return { ...prev, team: newTeam.filter((id) => id) };
      });
    } else {
      setOrderData((prev) => ({
        ...prev,
        [field]: newValue,
      }));
    }
    setErrorMessage('');
  };

  const handleAddPersonToggle = (type, index = null) => {
    if (type === 'supervisor') {
      setIsAddingSupervisor(true);
    } else if (type === 'preparer') {
      setIsAddingPreparer(true);
    } else if (type === 'team' && index !== null) {
      setIsAddingTeamMember((prev) => {
        const newState = [...prev];
        newState[index] = true;
        return newState;
      });
    }
    setUsernameInput('');
  };

  const handleAddSupervisor = () => {
    const foundUser = outsideUsers.find((u) => u.username === usernameInput.trim());
    if (foundUser) {
      if ([orderData.preparerId, ...orderData.team].includes(foundUser.id)) {
        setErrorMessage('This person is already assigned to another role.');
      } else {
        setOrderData((prev) => ({
          ...prev,
          supervisorId: foundUser.id,
        }));
        setIsAddingSupervisor(false);
        setErrorMessage('');
      }
    } else {
      setErrorMessage('User does not exist.');
    }
  };

  const handleAddPreparer = () => {
    const foundUser = outsideUsers.find((u) => u.username === usernameInput.trim());
    if (foundUser) {
      if ([orderData.supervisorId, ...orderData.team].includes(foundUser.id)) {
        setErrorMessage('This person is already assigned to another role.');
      } else {
        setOrderData((prev) => ({
          ...prev,
          preparerId: foundUser.id,
        }));
        setIsAddingPreparer(false);
        setErrorMessage('');
      }
    } else {
      setErrorMessage('User does not exist.');
    }
  };

  const handleAddTeamMember = (index) => {
    const foundUser = outsideUsers.find((u) => u.username === usernameInput.trim());
    if (foundUser) {
      if ([orderData.supervisorId, orderData.preparerId, ...orderData.team].includes(foundUser.id)) {
        setErrorMessage('This person is already assigned to another role.');
      } else {
        setOrderData((prev) => {
          const newTeam = [...prev.team];
          newTeam[index] = foundUser.id;
          return { ...prev, team: newTeam };
        });
        setIsAddingTeamMember((prev) => {
          const newState = [...prev];
          newState[index] = false;
          return newState;
        });
        setErrorMessage('');
      }
    } else {
      setErrorMessage('User does not exist.');
    }
  };

  const handleCancelAddSupervisor = () => {
    setIsAddingSupervisor(false);
    setUsernameInput('');
    setErrorMessage('');
  };

  const handleCancelAddPreparer = () => {
    setIsAddingPreparer(false);
    setUsernameInput('');
    setErrorMessage('');
  };

  const handleCancelAddTeamMember = (index) => {
    setIsAddingTeamMember((prev) => {
      const newState = [...prev];
      newState[index] = false;
      return newState;
    });
    setUsernameInput('');
    setErrorMessage('');
  };

  const handleDeleteSupervisor = () => {
    setOrderData((prev) => ({
      ...prev,
      supervisorId: '',
    }));
    setIsAddingSupervisor(false);
  };

  const handleDeletePreparer = () => {
    setOrderData((prev) => ({
      ...prev,
      preparerId: '',
    }));
    setIsAddingPreparer(false);
  };

  const handleDeleteTeamMember = (index) => {
    setOrderData((prev) => {
      const newTeam = [...prev.team];
      newTeam.splice(index, 1);
      return { ...prev, team: newTeam };
    });
    setIsAddingTeamMember((prev) => {
      const newState = [...prev];
      newState.splice(index, 1);
      if (newState.length === 0) newState.push(false);
      return newState;
    });
  };

  const handleAddAnotherMember = () => {
    if (orderData.team.length < 6) {
      setOrderData((prev) => ({
        ...prev,
        team: [...prev.team, ''],
      }));
      setIsAddingTeamMember((prev) => [...prev, false]);
    } else {
      setErrorMessage('Maximum of 6 team members allowed.');
    }
  };

  const handleToggleMode = () => {
    setIsCreateMode((prev) => !prev);
    setOrderData((prev) => ({
      ...prev,
      orderNumber: null,
      workPermitNumber: null,
      turbineId: '',
      scopeOfWorkId: '',
      workPermitId: null,
      supervisorId: '',
      preparerId: '',
      team: [],
      startDateTime: '',
      endDateTime: '',
    }));
    setIsOrderNumberLocked(false);
    setIsWorkPermitNumberLocked(false);
    setIsAddingTeamMember([false]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    const token = localStorage.getItem('access_token');
    if (!token) {
      setErrorMessage('No authentication token found. Please log in.');
      return;
    }

    if (!otherScopeId && orderData.workScopeReal) {
      setErrorMessage('Custom scope is not supported because "Other" option is not available.');
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const teamData = {
      name: 'team',
      team_leader: orderData.supervisorId,
      person_responsible_for_preparation_of_work_place: orderData.preparerId,
      team: [
        orderData.supervisorId,
        orderData.preparerId,
        ...orderData.team,
      ].filter((id) => id),
    };

    console.log('Dane wysyłane do /teams/:', teamData);

    if (!teamData.team_leader) {
      setErrorMessage('Choose Supervisor');
      return;
    }
    if (!teamData.person_responsible_for_preparation_of_work_place) {
      setErrorMessage('Choose Preparer');
      return;
    }

    let teamId;
    try {
      const teamResponse = await axios.post(`${API_BASE_URL}/teams/`, teamData, config);
      console.log('Team API Response:', teamResponse.data);
      teamId = teamResponse.data.id;
    } catch (error) {
      console.error('Error creating team:', error);
      setErrorMessage(error.response?.data?.detail || 'Error creating team. Please try again.');
      return;
    }

    const submitData = {
      order_number: orderData.orderNumber,
      work_permit_number: orderData.workPermitNumber || null,
      turbine: orderData.turbineId,
      work_scope: orderData.scopeOfWorkId,
      work_scope_real: orderData.workScopeReal || null,
      status: 'signed',
      company_to: 1,
      company: user?.company,
      team: teamId,
      planned_date_start: orderData.startDateTime || null,
      planned_date_end: orderData.endDateTime || null,
      sign_date: new Date().toISOString(),
    };

    console.log('Dane wysyłane do /workpermit/:', submitData);

    if (!submitData.order_number) {
      setErrorMessage('Enter Order Number');
      return;
    }    
    if (!submitData.turbine) {
      setErrorMessage('Choose Turbine');
      return;
    }
    if (!submitData.work_scope) {
      setErrorMessage('Choose Scope of Work');
      return;
    }
    if (submitData.work_scope === otherScopeId && !submitData.work_scope_real) {
      setErrorMessage('Please provide a description for the custom scope of work.');
      return;
    }
    if (!submitData.team || !submitData.company || !submitData.sign_date) {
      setErrorMessage('Invalid data - try again');
      return;
    }
    if (!submitData.planned_date_start) {
      setErrorMessage('Choose Date Start');
      return;
    }
    if (!submitData.planned_date_end) {
      setErrorMessage('Choose Date End');
      return;
    }

    const startDate = new Date(submitData.planned_date_start);
    const endDate = new Date(submitData.planned_date_end);
    const currentDate = new Date();
    const threeMinutesAgo = new Date(currentDate.getTime() - 3 * 60 * 1000);

    if (startDate < threeMinutesAgo) {
      setErrorMessage('Start date cannot be in the past');
      return;
    }
    if (endDate < startDate) {
      setErrorMessage('The end date cannot be earlier than the start date');
      return;
    }

    try {
      if (orderData.workPermitId) {
        const response = await axios.put(
          `${API_BASE_URL}/workpermit/${orderData.workPermitId}/`,
          submitData,
          config
        );
        console.log('Work Permit Update API Response:', response.data);
        setSuccessMessage('Work permit updated successfully!');
      } else {
        const existingOrder = pendingWorkPermits.find(
          (permit) => permit.order_number === orderData.orderNumber
        );
        if (existingOrder) {
          setErrorMessage('Order number already exists. Please choose a different number or select it from the list.');
          return;
        }

        if (submitData.work_permit_number) {
          const existingPermit = pendingWorkPermits.find(
            (permit) => permit.work_permit_number === orderData.workPermitNumber
          );
          if (existingPermit) {
            setErrorMessage('Work permit number already exists. Please choose a different number or select it from the list.');
            return;
          }
        }

        const response = await axios.post(`${API_BASE_URL}/workpermit/`, submitData, config);
        console.log('Work Permit Create API Response:', response.data);
        setSuccessMessage('Work permit created successfully!');
      }

      setOrderData({
        orderNumber: '',
        workPermitNumber: '',
        turbineId: '',
        scopeOfWorkId: '',
        workScopeReal: '',
        supervisorId: '',
        preparerId: '',
        team: [],
        startDateTime: '',
        endDateTime: '',
        workPermitId: null,
      });
      setIsAddingTeamMember([false]);
      setIsCreateMode(false);
      setIsOrderNumberLocked(false);
      setIsWorkPermitNumberLocked(false);
      await fetchPendingWorkPermits();
      onNavigate('request-list', 'all');
    } catch (error) {
      console.error('Error submitting work permit:', error);
      if (error.response?.data?.non_field_errors) {
        const nonFieldError = error.response.data.non_field_errors[0];
        if (nonFieldError.includes('work_permit_number, company must make a unique set')) {
          setErrorMessage('Work permit number already exists for your company.');
        } else {
          setErrorMessage(nonFieldError || 'Error processing work permit. Please try again.');
        }
      } else {
        setErrorMessage(error.response?.data?.detail || 'Error processing work permit. Please try again.');
      }
    }
  };

  if (loading) {
    return (
      <div className="bg-slate-50 h-[calc(100vh-50px)] p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-slate-50 h-[calc(100vh-50px)] p-6 overflow-hidden">
      <div className="flex flex-col max-w-6xl mx-auto h-full bg-white p-6 rounded-xl shadow-lg border border-slate-200 overflow-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-slate-900">
            {workPermitId ? 'Send Work Permit (Vestas)' : 'Create New Work Permit (Vestas)'}
          </h2>
          {!workPermitId && (
            <Button
              type="button"
              onClick={handleToggleMode}
              className="px-4 py-2 bg-brand-500 text-white font-bold rounded-lg hover:bg-brand-600 transition-colors"
            >
              {isCreateMode ? 'Select Mode' : 'Create Mode'}
            </Button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="flex-1 space-y-6">
          <div className="flex flex-col h-full">
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Order Number</label>
                {workPermitId ? (
                  <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                    {orderData.orderNumber || 'N/A'}
                  </div>
                ) : isCreateMode ? (
                  <input
                    type="text"
                    value={orderData.orderNumber}
                    onChange={(e) => handleManualInputChange('orderNumber', e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                    placeholder="Enter order number"
                    disabled={isOrderNumberLocked}
                    required
                  />
                ) : (
                  <Select
                    options={orderOptions}
                    value={
                      orderData.orderNumber
                        ? orderOptions.find((option) => option.value === orderData.orderNumber) || null
                        : null
                    }
                    onChange={handleOrderNumberChange}
                    placeholder="Select an order number..."
                    isClearable
                    isDisabled={isOrderNumberLocked}
                    className="basic-single"
                    classNamePrefix="select"
                  />
                )}
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Work Permit Number</label>
                {workPermitId ? (
                  <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                    {orderData.workPermitNumber || 'N/A'}
                  </div>
                ) : isCreateMode ? (
                  <input
                    type="text"
                    value={orderData.workPermitNumber}
                    onChange={(e) => handleManualInputChange('workPermitNumber', e.target.value)}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                    placeholder="Enter work permit number"
                    disabled={isWorkPermitNumberLocked}
                  />
                ) : (
                  <Select
                    options={workPermitOptions}
                    value={
                      orderData.workPermitNumber
                        ? workPermitOptions.find((option) => option.value === orderData.workPermitNumber) || null
                        : null
                    }
                    onChange={handleWorkOrderChange}
                    placeholder="Select a pending work permit..."
                    isClearable
                    isDisabled={isWorkPermitNumberLocked}
                    className="basic-single"
                    classNamePrefix="select"
                  />
                )}
              </div>

              {(isCreateMode || orderData.workPermitNumber || workPermitId || orderData.orderNumber ) && (
                <>
                  <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Turbine</label>
                    {workPermitId ? (
                      <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                        {turbineLabel}
                      </div>
                    ) : (
                      <Select
                        options={turbineOptions}
                        value={turbineOptions.find((option) => option.value === orderData.turbineId) || null}
                        onChange={(option) => handleChange('turbineId', option)}
                        placeholder="Select or type to filter turbines..."
                        isClearable
                        isDisabled={isOrderNumberLocked || isWorkPermitNumberLocked}
                        className="basic-single"
                        classNamePrefix="label"
                      />
                    )}
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Scope of Work</label>
                    {workPermitId ? (
                      <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                        {scopeLabel}
                      </div>
                    ) : (
                      <CreatableSelect
                        options={scopeOptions}
                        value={
                          orderData.scopeOfWorkId === otherScopeId
                            ? { value: otherScopeId, label: orderData.workScopeReal || 'Other' }
                            : scopeOptions.find((option) => option.value === orderData.scopeOfWorkId) || null
                        }
                        onChange={(option) => handleChange('scopeOfWorkId', option)}
                        placeholder="Select or type a custom scope..."
                        isClearable
                        isDisabled={isOrderNumberLocked || isWorkPermitNumberLocked || !otherScopeId}
                        className="basic-single"
                        classNamePrefix="select"
                        formatCreateLabel={(inputValue) => `Use custom scope: "${inputValue}"`}
                      />
                    )}
                  </div>
                </>
              )}

              <div className="mt-8 flex items-end space-x-3">
                <div className="flex-1">
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Choose Supervisor</label>
                  {orderData.supervisorId ? (
                    <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                      {selectedSupervisor?.username} ({selectedSupervisor?.first_name} {selectedSupervisor?.last_name})
                    </div>
                  ) : isAddingSupervisor ? (
                    <input
                      type="text"
                      value={usernameInput}
                      onChange={(e) => setUsernameInput(e.target.value)}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                      placeholder="Enter username"
                    />
                  ) : (
                    <Select
                      options={supervisorOptions}
                      value={supervisorOptions.find((option) => option.value === orderData.supervisorId) || null}
                      onChange={(option) => handleChange('supervisorId', option)}
                      placeholder="Select or type to filter supervisors..."
                      isClearable
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  )}
                </div>
                {orderData.supervisorId ? (
                  <Button type="button" onClick={handleDeleteSupervisor} className="px-4 py-2 text-sm font-bold text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors">
                    Delete
                  </Button>
                ) : isAddingSupervisor ? (
                  <>
                    <Button type="button" onClick={handleAddSupervisor} className="px-4 py-2 text-sm font-bold text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-colors">
                      Add
                    </Button>
                    <Button type="button" variant="outline" onClick={handleCancelAddSupervisor} className="px-4 py-2 text-sm font-bold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors">
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Button type="button" onClick={() => handleAddPersonToggle('supervisor')} className="px-4 py-2 text-sm font-bold text-brand-600 bg-brand-50 border border-brand-200 rounded-lg hover:bg-brand-100 transition-colors">
                    Add Person
                  </Button>
                )}
              </div>

              <div className="flex items-end space-x-3">
                <div className="flex-1">
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Choose Preparer</label>
                  {orderData.preparerId ? (
                    <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                      {selectedPreparer?.username} ({selectedPreparer?.first_name} {selectedPreparer?.last_name})
                    </div>
                  ) : isAddingPreparer ? (
                    <input
                      type="text"
                      value={usernameInput}
                      onChange={(e) => setUsernameInput(e.target.value)}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                      placeholder="Enter username"
                    />
                  ) : (
                    <Select
                      options={preparerOptions}
                      value={preparerOptions.find((option) => option.value === orderData.preparerId) || null}
                      onChange={(option) => handleChange('preparerId', option)}
                      placeholder="Select or type to filter preparers..."
                      isClearable
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  )}
                </div>
                {orderData.preparerId ? (
                  <Button type="button" onClick={handleDeletePreparer} className="px-4 py-2 text-sm font-bold text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors">
                    Delete
                  </Button>
                ) : isAddingPreparer ? (
                  <>
                    <Button type="button" onClick={handleAddPreparer} className="px-4 py-2 text-sm font-bold text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-colors">
                      Add
                    </Button>
                    <Button type="button" variant="outline" onClick={handleCancelAddPreparer} className="px-4 py-2 text-sm font-bold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors">
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Button type="button" onClick={() => handleAddPersonToggle('preparer')} className="px-4 py-2 text-sm font-bold text-brand-600 bg-brand-50 border border-brand-200 rounded-lg hover:bg-brand-100 transition-colors">
                    Add Person
                  </Button>
                )}
              </div>

              {orderData.team.map((memberId, index) => (
                <div key={index} className="flex items-end space-x-3">
                  <div className="flex-1">
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                      Other Member {index + 1}
                    </label>
                    {memberId ? (
                      <div className="w-full px-3 py-2 border border-slate-300 rounded-lg bg-slate-50 text-slate-700">
                        {(() => {
                          const member = outsideUsers.find((u) => u.id === memberId);
                          return member ? `${member.username} (${member.first_name} ${member.last_name})` : 'N/A';
                        })()}
                      </div>
                    ) : isAddingTeamMember[index] ? (
                      <input
                        type="text"
                        value={usernameInput}
                        onChange={(e) => setUsernameInput(e.target.value)}
                        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                        placeholder="Enter username"
                      />
                    ) : (
                      <Select
                        options={memberOptions}
                        value={memberOptions.find((option) => option.value === memberId) || null}
                        onChange={(option) => handleChange('team', option, index)}
                        placeholder="Select or type to filter members..."
                        isClearable
                        className="basic-single"
                        classNamePrefix="select"
                      />
                    )}
                  </div>
                  {memberId ? (
                    <Button type="button" onClick={() => handleDeleteTeamMember(index)} className="px-4 py-2 text-sm font-bold text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors">
                      Delete
                    </Button>
                  ) : isAddingTeamMember[index] ? (
                    <>
                      <Button type="button" onClick={() => handleAddTeamMember(index)} className="px-4 py-2 text-sm font-bold text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-colors">
                        Add
                      </Button>
                      <Button type="button" variant="outline" onClick={() => handleCancelAddTeamMember(index)} className="px-4 py-2 text-sm font-bold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors">
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <Button type="button" onClick={() => handleAddPersonToggle('team', index)} className="px-4 py-2 text-sm font-bold text-brand-600 bg-brand-50 border border-brand-200 rounded-lg hover:bg-brand-100 transition-colors">
                      Add Person
                    </Button>
                  )}
                </div>
              ))}

              {orderData.team.length < 6 && (
                <div className="flex justify-start items-end">
                  <Button type="button" onClick={handleAddAnotherMember} className="px-4 py-2 text-sm font-bold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors">
                    Add another member
                  </Button>
                </div>
              )}
            </div>

            <div className="mb-6 mt-4 grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">From</label>
                <input
                  type="datetime-local"
                  value={orderData.startDateTime}
                  onChange={(e) => handleManualInputChange('startDateTime', e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">To</label>
                <input
                  type="datetime-local"
                  value={orderData.endDateTime}
                  onChange={(e) => handleManualInputChange('endDateTime', e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                />
              </div>
            </div>

            {errorMessage && <div className="text-red-600 text-sm font-medium bg-red-50 px-4 py-2 rounded-lg">{errorMessage}</div>}
            {successMessage && <div className="text-emerald-600 text-sm font-medium bg-emerald-50 px-4 py-2 rounded-lg">{successMessage}</div>}

            <div className="flex-1 flex justify-end items-end">
              <div className="flex items-center gap-4">
                <Button
                  variant="outline"
                  className="px-6 py-2.5 bg-white border border-slate-300 font-bold text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
                  onClick={() => onNavigate('request-list')}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="px-6 py-2.5 bg-brand-500 font-bold text-white rounded-lg hover:bg-brand-600 transition-colors shadow-lg shadow-brand-500/20"
                >
                  {workPermitId ? 'Send Work Permit' : 'Send Work Permit'}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestForm;